<template>
	<div style="width:400px; height:200px;" v-on:keyup.esc="close()">
		<table class="view_tbl">
			<colgroup>
				<col style="" />
			</colgroup>
			<tbody>
				<tr>
					<td>
						<select class="tbl_select full_int" v-model="update_remark">
							<option v-for="(remark, index) in update_remarks" :value="remark" v-bind:key="index">{{ remark }}</option>
							<option :value="null">Write yourself</option>
						</select>
					</td>
				</tr>
				<tr>
					<td><input type="text" v-model.trim="update_remark_text" :disabled="update_remark" class="tbl_int full_int" placeholder="Write update remark..." @focus="$event.target.select()" /></td>
				</tr>
			</tbody>
		</table>

		<div class="view_bottom_bt" style="padding-top:20px;">
			<a href="javascript:;" type="button" class="search_bt" @click="save()">Save & Close</a>
			<a href="javascript:;" type="button" class="gray_bt" @click="close()">Cancel</a>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
export default {
	data: function() {
		return {
			update_remark: null,
			update_remark_text: null,
		};
	},
	props: {
		update_remarks: Array,
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		async save() {
			if (!this.update_remark && !this.update_remark_text) {
				this.$toast.error('Select or Write yourself');
				return;
			}

			this.$emit('update-remark-call-back', this.update_remark ? this.update_remark : this.update_remark_text);
			this.close();
		},
	},
	created() {
		if (this.update_remarks.length > 0) this.update_remark = this.update_remarks[0];
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
